import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDollar2 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M8.25 3V0.75H9.75V3H13.5V4.5H6.93622C6.00494 4.5 5.25 5.25495 5.25 6.18622C5.25 7.01051 5.84593 7.71398 6.659 7.84949L11.5876 8.67092C13.124 8.92698 14.25 10.2562 14.25 11.8138C14.25 13.5735 12.8235 15 11.0638 15H9.75V17.25H8.25V15H3.75V13.5H11.0638C11.9951 13.5 12.75 12.7451 12.75 11.8138C12.75 10.9895 12.1541 10.286 11.341 10.1505L6.41241 9.32908C4.87605 9.07302 3.75 7.74376 3.75 6.18622C3.75 4.42652 5.17652 3 6.93622 3H8.25Z"
	})
});
export default SvgDollar2;
